import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { lagoon } from '@optum-lagoon/sdk';
import { qualtrics } from '@uhg-abyss/web/tools/event/listeners/qualtrics';
import { adobeAnalytics } from '@uhg-uhcpp-sde-core/monstera-utility';
import { qualtricsTags } from './tags/qualtrics';
import { adobeTags } from './tags/adobe';
import { greenfieldAdobeTags } from './tags/greenfieldAdobe';
import { asyncMessagingTags } from '@src/app/tools/analytics/tags/asyncMessaging';
import { asyncMessaging } from '@src/app/tools/asyncMessaging';
import { elasticApmAnalytics } from './elasticApm';
import { elasticApmTags } from './tags/elasticApm';

export const ADOBE_ANALYTICS_ID = 'adobe-analytics-digital-security';
export const ADOBE_GREENFIELD_ID = 'adobe-greenfield-digital-security';
const ANALYTICS_REGISTERED_KEY = '__DIGITAL_SECURITY_ANALYTICS_REGISTERED__';

let analyticsRegistered = false;

export const registerAnalytics = (data, qualtricsLink, liveChatUrl) => {
  const isAlreadyRegistered =
    analyticsRegistered ||
    (typeof window !== 'undefined' && window[ANALYTICS_REGISTERED_KEY]);

  if (isAlreadyRegistered) {
    return;
  }

  analyticsRegistered = true;
  if (typeof window !== 'undefined') {
    window[ANALYTICS_REGISTERED_KEY] = true;
  }

  const useGreenfieldAdobeDataLayer = Boolean(
    lagoon
      ?.getTable?.('feature-toggles')
      ?.getRow?.('GREENFIELD_ADOBE_DATA_LAYER')?.active
  );
  const adobeAnalyticsFeatureToggle = lagoon
    ?.getTable?.('feature-toggles')
    ?.getRow?.('ADOBE_ANALYTICS_TRACKING')?.active;
  const isAdobeAnalyticsEnabled =
    config('ANALYTICS_TRACKING') && (adobeAnalyticsFeatureToggle ?? true);

  // Legacy Adobe Analytics with appEventDataLayer (default)
  event.listener(
    adobeAnalytics({
      id: ADOBE_ANALYTICS_ID,
      enabled: isAdobeAnalyticsEnabled,
      logging: config('ANALYTICS_LOGGING'),
      useAdobeDataLayer: false, // Use legacy appEventDataLayer
      dataLayerKey: 'appEventDataLayer',
      maskClickTracking: true,
      useDebounce: true,
      debounceTime: 100,
      events: adobeTags,
      metadata: data,
    })
  );

  // New Adobe Data Layer (Greenfield) - controlled by feature flag
  event.listener(
    adobeAnalytics({
      id: ADOBE_GREENFIELD_ID,
      enabled: isAdobeAnalyticsEnabled && useGreenfieldAdobeDataLayer,
      logging: config('ANALYTICS_LOGGING'),
      useAdobeDataLayer: true, // Use new adobeDataLayer
      dataLayerKey: 'adobeDataLayer',
      maskClickTracking: true,
      useDebounce: true,
      debounceTime: 100,
      events: greenfieldAdobeTags,
      metadata: data,
    })
  );

  event.listener(
    qualtrics({
      id: 'qualtrics-digital-security',
      url: qualtricsLink,
      logging: config('ANALYTICS_LOGGING'),
      enabled: true,
      events: qualtricsTags,
      metadata: data,
    })
  );

  event.listener(
    elasticApmAnalytics({
      id: 'elastic-apm',
      enabled: true,
      logging: true,
      events: elasticApmTags,
      metadata: data,
    })
  );
  event.listener(
    asyncMessaging({
      id: 'async-messaging-liveperson',
      enabled: data,
      logging: true,
      events: asyncMessagingTags,
      metadata: data,
      liveChatUrl,
    })
  );
};
